import { render, staticRenderFns } from "./liveListPage.vue?vue&type=template&id=78bfaccd&"
import script from "./liveListPage.vue?vue&type=script&lang=ts&"
export * from "./liveListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports